import { connect } from 'react-redux';

import { filesConfig } from '../../../entity/HRM/filesConfig';
import BaseComponent from '../../../components/BaseComponent';

class Files extends BaseComponent {
    constructor(props) {
        super(props);
        this.config = { ...filesConfig };
        this.getResponse();
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.app.isAuthenticated,
    user: state.app.user,
});

export default connect(mapStateToProps)(Files);
